export default {
    props: {
        styleType: {
            required: false,
            type: String,
            default: ''
        },
        info: {
            required: true,
            type: Object
        }
    },
    computed: {
        url: function (){
            return _get(this, 'info.href', '/');
        },
        dividerBefore: function () {
            return _get(this, 'info.dividerBefore', false);
        }
    }
}
